import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import React from "react";
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/Icon_Delete.svg";

export interface HardwareItem {
	hardwareId: string;
	name: string;
}
export interface DataCenterItem {
	datacenterId: string;
	name: string;
}

export interface Port {
	id: number;
	hardwareResourceId: number //This comes from Hardware ep
	portName: string;
	portId: string;
	portNumber: string;
	portType: string;
	portStatus: string;
	l2Description: string;
	l3Description: string
	clientAssignation?: string;
}

export const columns: GenericTableColumn<Port>[] = [
	{
		header: "Port Name ",
		accessor: "portName",
	},
	{
		header: "Port ID",
		accessor: "portId",
	},
	{
		header: "Port Number",
		accessor: "portNumber",
	},
	{
		header: "Port Type",
		accessor: "portType",
	},
	{
		header: "Port Status",
		accessor: "portStatus",
	},
	{
		header: "L2 Description",
		accessor: "l2Description",
	},
	{
		header: "L3 Description",
		accessor: "l3Description",
	},
	// {
	// 	header: "Client Assignation",
	// 	accessor: "clientAssignation",
	// },

	{
		header: "Actions",
		// We only need a valid string for 'accessor'; real rendering is in renderCell
		accessor: "portType",
		renderCell: (row) => (
			<div className="flex items-center gap-2">
				{/* View Button */}
				<button
					className="
            px-3 py-1
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
          "
					onClick={() => {
						console.log("View data center:", row);
					}}
				>
					View
				</button>

				{/* Edit Button */}
				<button
					className="
            flex items-center justify-center
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
            w-10 h-10
          "
					onClick={() => {
						console.log("Edit data center:", row);
					}}
				>
					<IconEdit className="w-5 h-5" />
				</button>

				{/* Delete Button */}
				<button
					className="
            p-2
            border border-semantic-border-secondary
            rounded
            bg-red-50
            text-red-600
            hover:bg-red-100
          "
					onClick={() => {
						console.log("Delete data center:", row);
					}}
				>
					<IconDelete className="w-5 h-5" />
				</button>
			</div>
		),
	},
]